module.exports = __webpack_public_path__ + "img/bth_yaobu_pre.b29aee66.png";